export default function ignoreCacheUpdateReducer
    (state = { error:'', success:'', processing:false}, action)
{
    switch (action.type) {
        case 'CACHE_IGNORE_UPDATE_SUCCESS':
            return {...state, ...{success: action.success}};

        case 'CACHE_IGNORE_UPDATE_ERROR':
            return {...state, ...{error: action.error}};

        case 'CACHE_IGNORE_UPDATE_PROCESSING':
            return {...state, ...{processing: action.processing}};

        default: return state;
    }
}